import React from 'react';
import oldColored from '../../assets/oldcolored.png';

const MenuLogo = ({ className = '' }) => {
  return (
    <img 
      src={oldColored}
      className={`menu-logo-img ${className}`}
      alt="Logo"
    />
  );
};

export default MenuLogo;
